( function( $, document, window ) {
	'use strict';

	$( function() {
        const $target       = $( '.js-follow-mouse-target' );
        const $trigger      = $( '.js-follow-mouse-trigger' );
        const activeClass   = 'follow-mouse--is-active';
        const clickedClass  = 'follow-mouse--is-mousedown';

        const onMouseMove = ( e ) => {
            const targetOffset = $target.offset();
            const mouseX = e.pageX - targetOffset.left;
            const mouseY = e.pageY - targetOffset.top;

            $trigger.addClass( activeClass ).css( {
                left: mouseX - $trigger.width() / 2,
                top: mouseY - $trigger.height() / 2
            } );
        }

        const handleResize = () => {
            if ( window.matchMedia( '(min-width: 1024px)' ).matches ) {
                $target.on( 'mouseenter', () => {
                    $trigger.addClass( activeClass );
                    $( document ).on( 'mousemove', onMouseMove );
                } );

                $target.on( 'mouseleave', () => {
                    $trigger.removeClass( activeClass );
                    $( document ).off( 'mousemove', onMouseMove );
                } );
            } else {
                $target.off( 'mouseenter mouseleave' );
                $( document ).off( 'mousemove', onMouseMove );
            }
        }

        handleResize();

        $( window ).on( 'resize', () => {
            debounce( handleResize, 500 );
        } );

        $( document ).on( 'mouseup', () => {
            $trigger.removeClass( clickedClass );
            $trigger.removeClass( activeClass );
        } );
	} );
} )( jQuery, document, window );
